import { useEffect } from 'react';
import TextInput from './TextInput';

const DateInput = ({
  value,
  onChange,
  max,
  min,
  isValid = true,
  onValidationChange,
  ...props
}) => {
  
  useEffect(() => {
    if (onValidationChange) {
      // Empty value is considered valid
      if (!value || value.trim() === '') {
        onValidationChange(true);
        return;
      }
      
      let valid = true;
      const dateValue = new Date(value);
      
      if (isNaN(dateValue.getTime())) {
        valid = false;
      }
      
      if (valid && max) {
        const maxDate = new Date(max);
        if (dateValue > maxDate) {
          valid = false;
        }
      }
      
      if (valid && min) {
        const minDate = new Date(min);
        if (dateValue < minDate) {
          valid = false;
        }
      }
      
      onValidationChange(valid);
    }
  }, [value, max, min, onValidationChange]);
   
  return (
    <TextInput
      type="date"
      value={value}
      onChange={onChange}
      isValid={isValid}
      {...props}
    />
  );
};

export default DateInput;
